import React, { FC } from 'react';
import { useStyles } from './CloseEvalEopModal.styles';
import { RockyModal } from '@shared/components/RockyModal';
import { EvalEndOfProbation } from '@modules/EvaluationModule/pages/EvalPage/components/EvalEndOfProbation';
import { AsyncData } from '@shared/interfaces/asyncData';
import { EvalPageData } from '@modules/EvaluationModule/interfaces/EvalPageData';
import { useDispatch } from 'react-redux';
import { setFullEop } from '@modules/EvaluationModule/pages/EvalPage/redux/actions';
import { getEvaluationTerms } from '@shared/helpers/evaluationTerminology';

interface Props {
  closeModal: () => void;
  isModalOpen: boolean;
  evalData: AsyncData<EvalPageData>;
}

export const CloseEvalEopModal: FC<Props> = ({ closeModal, isModalOpen, evalData }) => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const evaluationTerms = getEvaluationTerms(evalData.data?.userHistory?.officeCountry);

  return (
    <RockyModal
      onClose={closeModal}
      isOpen={isModalOpen}
      title={evaluationTerms.waitSetResolution}
      crossIcon={false}
      modalStyles={styles.root}
    >
      <EvalEndOfProbation
        onCancel={closeModal}
        evalData={evalData}
        onSubmit={({ eopResult, nextEvalDate, failingReason, extendingReason }) => {
          dispatch(
            setFullEop({
              eopResult: eopResult,
              next_evaluation_date: nextEvalDate,
              notes: failingReason,
              notPassedReason: failingReason,
              extendedReason: extendingReason,
              closeEvalToo: true,
            })
          );
        }}
        isModal
      />
    </RockyModal>
  );
};
